import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faArrowLeft, faArrowRight, faCaretDown, faCaretRight, faSpinner } from '@fortawesome/free-solid-svg-icons';

import { DateDirective } from './directives/date.directive';
import { DropdownDirective } from './directives/dropdown.directive';
import { EqualValidator } from './directives/equal-validator.directive';
import { IbanValidatorDirective } from './directives/iban-validator.directive';
import { MatchOtherValidator } from './directives/match-other-validator.directive';
import { OnlyNumbersDirective } from './directives/only-numbers.directive';
import { PostalCodeFormatDirective } from './directives/postalcode-format.directive';
import { UpperCaseTextDirective } from './directives/uppercase.directive';
import { ValidationErrorDirective } from './directives/validation-error.directive';
import { CurrencyFormatPipe } from './pipes/currency-format.pipe';
import { DutchDateFormatPipe } from './pipes/dutch-date-format.pipe';

@NgModule({
  declarations: [
    DropdownDirective,
    EqualValidator,
    DateDirective,
    UpperCaseTextDirective,
    PostalCodeFormatDirective,
    OnlyNumbersDirective,
    IbanValidatorDirective,
    ValidationErrorDirective,
    MatchOtherValidator,
    CurrencyFormatPipe,
    DutchDateFormatPipe
  ],
  imports: [FontAwesomeModule],
  exports: [
    CommonModule,
    FontAwesomeModule,
    DropdownDirective,
    EqualValidator,
    DateDirective,
    UpperCaseTextDirective,
    PostalCodeFormatDirective,
    OnlyNumbersDirective,
    IbanValidatorDirective,
    ValidationErrorDirective,
    MatchOtherValidator,
    CurrencyFormatPipe,
    DutchDateFormatPipe
  ]
})
export class SharedModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(faArrowLeft);
    library.addIcons(faArrowRight);
    library.addIcons(faCaretDown);
    library.addIcons(faCaretRight);
    library.addIcons(faSpinner);
  }
}
